import { API_BASE_URL } from "../urls.api";

export const GET_CONFIGURATION_URL = `${API_BASE_URL}/configuration`;
